import {initDebug, env} from '../utils/commons'
import axios from 'axios'
import QS from 'qs'

class Platform {
    constructor(params) {
        this.params = params
    }

    /**
     * 初始化操作
     */
    init() {
        initDebug()

        // 企业微信/小程序自动登录用
        axios.defaults.headers.common['htReferer'] = location.href

        // 解决IOS页面返回不刷新的问题
        if (env.ios) window.onpageshow = e => e.persisted && window.location.reload()

        return new Promise((resolve, reject) => {
            resolve()
        })
    }

    /**
     * jssdk鉴权
     */
    config() {
    }

    /**
     * 页面url变化时执行此方法，可在此执行一些操作，比如隐藏右上角按钮
     * @param to
     */
    urlChange(to) {
        // 判断是否需要隐藏右上角菜单
        if (to.meta.hideOptionMenu) this.hideOptionMenu()
    }

    /**
     * 关闭页面
     */
    close() {
    }

    /**
     * 获取定位
     */
    getLocation() {
    }

    /**
     * 打开会话（钉钉、微信）
     * @param userIds 用户id，逗号分隔
     * @param groupName 可选
     */
    openChat(userIds, groupName = '') {
    }

    /**
     * 设置页面标题
     * @param title
     */
    setTitle(title){
        document.title = title
    }

    /**
     * 隐藏右上角按钮
     */
    hideOptionMenu() {
    }

    /**
     * 开始录音
     */
    startRecord() {
    }

    /**
     * 停止录音
     */
    stopRecord() {
    }

    /**
     * 录音转换为文字
     */
    translateVoice() {
    }
    navigate(url) {
        const [href,path=""] = url.split("#")
        const [urlPath,querystr = ""] = href.indexOf('?')?href.split('?'):[href];
        const query = QS.parse(querystr)
        window.location.href = `${urlPath}?${QS.stringify({...QS.parse(location.search.split('?')[1]),...query})}${path?"#"+path:""}`;
    }
}

export default Platform